<div class="row form-group">                               
    <div class="col-sm-2">
        <mat-form-field style="display:flex;flex-direction: column;">
            <mat-label>Institution ID</mat-label>
            <input matInput readonly="true" placeholder="xx-xxx-xxxx" value="{{student.institutionId | mask: '00-000-0000'}}" >
        </mat-form-field>
    </div>
    <div class="col-sm-2">
        <mat-form-field style="display:flex;flex-direction: column;">
            <mat-label>Workday ID</mat-label>
            <input matInput readonly="true" placeholder="xxxxxxxx" value="{{student.workdayId | mask: '00000000'}}" >
        </mat-form-field>
    </div>  
    <div class="col-sm-3">
        <mat-form-field style="display:flex;flex-direction: column;">
            <mat-label>Name</mat-label>
            <input matInput readonly="true" placeholder="Full Name" value="{{student.person.lastName}}, {{student.person.firstName}} {{student.person.middleName}}" >
        </mat-form-field>
    </div> 
    <div class="col-sm-3">
      <mat-form-field style="display:flex;flex-direction: column;">
        <mat-label>Primary Sport</mat-label>
        <input matInput readonly="true" placeholder="Primary Sport" value="{{student.primarySport==null?' ':student.primarySport}}">
      </mat-form-field>
    </div> 
    <div class="col-sm-2">
        <mat-form-field style="display:flex;flex-direction: column;">
            <mat-label>Last Season</mat-label>
            <input matInput readonly="true" placeholder="Last Season" value="{{student.lastSeason==''?' ':student.lastSeason}}"  >
        </mat-form-field>
    </div>                             
</div>
